import {
    BulkUpdateUsersInput,
    BulkUpdateUsersResponse,
    ResolveUsersByEmailsInput,
    ResolveUsersByEmailsResponse,
} from "../../../types/api/admin/bulkUsers";
import { request } from "../../apiService";

export const resolveUsersByEmails = async (emails: string[]) => {
    return await request<
        ResolveUsersByEmailsResponse,
        ResolveUsersByEmailsInput
    >(`/v3/admin/users/by-emails`, {
        method: "POST",
        input: { emails },
    });
};

export const bulkUpdateUsers = async (input: BulkUpdateUsersInput) => {
    return await request<BulkUpdateUsersResponse, BulkUpdateUsersInput>(
        `/v3/admin/users/bulk`,
        {
            method: "POST",
            input,
        }
    );
};
